<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <departamentosGraph :dataset="dataset"></departamentosGraph>
            </div>          
        </div>
        <div class="row">
            <div class="col-12">
                <modalidadesGraph :dataset="dataset"></modalidadesGraph>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <planesGraphBar :dataset="dataset"></planesGraphBar>                
            </div>
        </div>
    </div>

    
</template>


<script>

	import modalidadesGraph from '../components/modalidadesGraph.vue'
	import departamentosGraph from '../components/departamentosGraph.vue'
	import planesGraphBar from '../components/planesGraphBar.vue'

	export default {
	name: 'graficosPlanes',
	props: {
    dataset: Array
  },
  components: {
    planesGraphBar,
    modalidadesGraph,
    departamentosGraph
  }
}
</script>